import $i18n from 'panda-i18n';
import * as React from 'react';
import cx from 'classnames';
import { useValue } from '@/utils/use-value';
import isNumber from 'lodash/isNumber';
import './cn-input-textarea.scss';
export const CnInputTextArea = (props) => {
    const { className, type = 'normal', rows = 3, placeholder = $i18n.get({
        id: 'gxms-pc_Enter.CNTM',
        dm: '请输入',
        ns: 'CnInputTextarea',
    }), 
    // keyboardType,
    // useOriginalRef,
    disabled, maxLength, showLimitHint, readOnly, autoFocus, align, highlightable, 
    // composition,
    onFocus, onBlur, onChange,
    // onConfirm,
    // onCompositionStart,
    // onCompositionEnd,
     } = props;
    const clsPrefix = 'cn-ui-m-textarea';
    const [isFocused, setIsFocused] = React.useState(false);
    const [value, setValue, isControlled, setPropValue] = useValue(props, '', {
        fitValue: (v) => {
            if (isNumber(maxLength) && maxLength > 0) {
                return `${v}`.length > maxLength ? `${v}`.substr(0, maxLength) : v;
            }
            return v;
        },
    });
    // className样式计算
    const classes = {
        textareaContainer: cx(clsPrefix, `${clsPrefix}--${type}`, {
            [`${clsPrefix}--highlighted`]: highlightable && isFocused,
            [`${clsPrefix}--read-only`]: readOnly,
        }, className),
        readOnly: cx(`${clsPrefix}-read-only-wrapper`),
        textarea: cx(`${clsPrefix}-wrapper`, `${clsPrefix}--${align}`),
    };
    /** onChange事件 */
    const onChangeHandle = (e) => {
        const val = e.target.value;
        if (isControlled) {
            // 受控模式下同时更新 prop 值
            setPropValue(val);
        }
        else {
            setValue(val);
        }
        onChange?.(val, e);
    };
    /** onFocus事件 */
    const onFocusHandle = () => {
        onFocus?.();
        setIsFocused(true);
    };
    /** onBlur事件 */
    const onBlurHandle = () => {
        onBlur?.();
        setIsFocused(false);
    };
    /** 只读模式，没有其他，只读态高度自适应 */
    const renderReadOnly = () => {
        // return <CnReadonly>{value}</CnReadonly>;
        return React.createElement("div", null, value);
    };
    /** textarea 输入模式 */
    const renderTextarea = () => {
        return (React.createElement("textarea", { className: classes.textarea, rows: rows, value: value, placeholder: placeholder, autoFocus: autoFocus, maxLength: maxLength, disabled: !!disabled, onInput: onChangeHandle, onChange: onChangeHandle, onBlur: onBlurHandle, onFocus: onFocusHandle }));
    };
    /** 有限制输入长度时，右侧显示输入字数 */
    const renderLengthTips = () => {
        if (!maxLength || !showLimitHint || !!readOnly || !!disabled) {
            return null;
        }
        return (React.createElement("div", { className: `${clsPrefix}-length-tips` },
            React.createElement("span", { className: `${clsPrefix}-length-tips-value` }, value.length),
            maxLength ? React.createElement("span", null,
                "/",
                maxLength) : null));
    };
    return (React.createElement("div", { className: classes.textareaContainer },
        readOnly ? renderReadOnly() : renderTextarea(),
        renderLengthTips()));
};
CnInputTextArea.displayName = 'CnInputTextArea';
CnInputTextArea.defaultProps = {
    showLimitHint: false,
};
